import React from 'react'
import "./Tab_content_holder.css"
import Mobile_recharge_plan_card from '../../../../../common_components/common_cards/mobile_recharge_plan_card/Mobile_recharge_plan_card'
import Mobile_prepaid_plan_card from '../../../../../common_components/common_cards/mobile_prepaid_plan_card/Mobile_prepaid_plan_card'

function Tab_content_holder({ planHeading }) {
    return (
        <>
            <section className='Tab_content_holder'>
                <Mobile_prepaid_plan_card planName={"Airtel Prepaid"} number={"8864732301"} changeLink={"/mobile-recharge"} />

                <div className="select_plan_hodler box_holder ">
                    <div className="heading_text">
                        <h6>{planHeading}</h6>
                    </div>

                    <Mobile_recharge_plan_card />
                    <Mobile_recharge_plan_card tagClassName="best_plan_tag" tagName="Best 5G Plan" />
                    <Mobile_recharge_plan_card tagClassName="limited_plan_tag" tagName="Limeted Plan" />
                </div>
            </section>
        </>
    )
}

export default Tab_content_holder